export default __webpack_public_path__ + "static/media/docker.c24afd5f.svg";